<template>
    <login-form :error="error" @submit="submit" class="pa-10"></login-form>
</template>

<script>
import LoginForm from '@/components/auth/LoginForm'
import { sync } from 'vuex-pathify'

export default {
    components: {
        LoginForm
    },

    computed: sync('home', ['credential', 'loginPassword', 'error']),

    methods: {
        submit() {
            this.error = false

            this.$store.dispatch('auth/login', {
                data: {
                    credential: this.credential,
                    password: this.loginPassword
                }
            })
                .then(() => {
                    this.$router.replace({ name: 'dashboard' })
                        .catch(() => {}) // Prevet uncaught error when this replace is replaced in route guard
                })
                .catch(error => {
                    if (error.response && error.response.status == 401) {
                        this.error = true
                    }
                })
        }
    }
}
</script>
